import React from 'react';

interface ChartBoxProps {
    children: React.ReactNode;
}

const ChartBox = ({ children }: ChartBoxProps) => {
    return <div className="h-70 w-full max-w-6xl">{children}</div>;
};

export default ChartBox;
